var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAmericanExpress = function SvgAmericanExpress(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 38 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.609375 3C0.609375 1.34315 1.95252 0 3.60938 0H34.9137C36.5706 0 37.9137 1.34315 37.9137 3V23C37.9137 24.6569 36.5706 26 34.9137 26H3.60938C1.95252 26 0.609375 24.6569 0.609375 23V3Z",
    fill: "#016FD0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85547 19.664V13.8643H14.0289L14.6913 14.7232L15.3755 13.8643H37.7837V19.2641C37.7837 19.2641 37.1977 19.6582 36.5199 19.664H24.1121L23.3653 18.7498V19.664H20.9182V18.1034C20.9182 18.1034 20.5839 18.3213 19.8612 18.3213H19.0283V19.664H15.3232L14.6618 18.7867L13.9902 19.664H7.85547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646484 9.4931L2.03863 6.26468H4.44619L5.23625 8.07311V6.26468H8.22907L8.69939 7.57176L9.15535 6.26468H22.59V6.92179C22.59 6.92179 23.2963 6.26468 24.457 6.26468L28.816 6.27983L29.5924 8.06459V6.26468H32.097L32.7863 7.28988V6.26468H35.3138V12.0644H32.7863L32.1257 11.0359V12.0644H28.446L28.0759 11.1502H27.0867L26.7227 12.0644H24.2272C23.2285 12.0644 22.59 11.4207 22.59 11.4207V12.0644H18.8275L18.0807 11.1502V12.0644H4.08952L3.71973 11.1502H2.73365L2.36646 12.0644H0.646484L0.646484 9.4931Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.654297 11.3223L2.53199 6.97968H3.95552L5.83142 11.3223H4.58202L4.23736 10.4527H2.22323L1.87677 11.3223H0.654297ZM3.84085 9.50993L3.22691 7.99036L2.61119 9.50993H3.84085Z",
    fill: "#016FD0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95898 11.3216V6.97894L7.69619 6.98536L8.70661 9.78523L9.69283 6.97894H11.4161V11.3216H10.3247V8.12175L9.16777 11.3216H8.21059L7.05042 8.12175V11.3216H5.95898Z",
    fill: "#016FD0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1641 11.3216V6.97894H15.7256V7.95033H13.267V8.69315H15.6681V9.60739H13.267V10.3788H15.7256V11.3216H12.1641Z",
    fill: "#016FD0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3574 11.3223V6.97968H18.7862C19.591 6.97968 20.3121 7.47469 20.3121 8.38854C20.3121 9.16975 19.7041 9.67293 19.1147 9.7224L20.5508 11.3223H19.2171L17.9084 9.77954H17.4489V11.3223H16.3574ZM18.6964 7.95111H17.4488V8.86536H18.7126C18.9313 8.86536 19.2134 8.69674 19.2134 8.40824C19.2134 8.18399 18.9957 7.95111 18.6964 7.95111Z",
    fill: "#016FD0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8722 11.3216H20.7578V6.97894H21.8722V11.3216Z",
    fill: "#016FD0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5134 11.3216H24.2729C23.109 11.3216 22.4023 10.4095 22.4023 9.16813C22.4023 7.89609 23.1011 6.97894 24.5708 6.97894H25.7772V8.00747H24.5267C23.9301 8.00747 23.5081 8.47063 23.5081 9.17884C23.5081 10.0198 23.9906 10.3731 24.6857 10.3731H24.9729L24.5134 11.3216Z",
    fill: "#016FD0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0117 11.3223L26.8894 6.97968H28.3129L30.1888 11.3223H28.9394L28.5948 10.4527H26.5807L26.2342 11.3223H25.0117ZM28.1983 9.50993L27.5843 7.99036L26.9686 9.50993H28.1983Z",
    fill: "#016FD0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3164 11.3216V6.97894H31.704L33.4758 9.70739V6.97894H34.5672V11.3216H33.2245L31.4078 8.52173V11.3216H30.3164Z",
    fill: "#016FD0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60156 18.9213V14.5786H12.1631V15.55H9.70448V16.2928H12.1056V17.2071H9.70448V17.9785H12.1631V18.9213H8.60156Z",
    fill: "#016FD0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0547 18.9213V14.5786H29.6162V15.55H27.1576V16.2928H29.5473V17.2071H27.1576V17.9785H29.6162V18.9213H26.0547Z",
    fill: "#016FD0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.303 18.9213L14.0371 16.7767L12.2617 14.5786H13.6368L14.6941 15.9375L15.755 14.5786H17.0762L15.3242 16.7499L17.0615 18.9213H15.6866L14.66 17.5838L13.6583 18.9213H12.303Z",
    fill: "#016FD0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1895 18.922V14.5793H19.6003C20.5895 14.5793 21.1674 15.2135 21.1674 16.04C21.1674 17.0376 20.4306 17.5506 19.4585 17.5506H18.3096V18.922H17.1895ZM19.5196 15.5614H18.3097V16.5614H19.516C19.8348 16.5614 20.0581 16.3512 20.0581 16.0614C20.0581 15.7529 19.8336 15.5614 19.5196 15.5614Z",
    fill: "#016FD0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6426 18.9213V14.5786H24.0714C24.8761 14.5786 25.5972 15.0736 25.5972 15.9875C25.5972 16.7687 24.9893 17.2719 24.3999 17.3213L25.836 18.9213H24.5022L23.1936 17.3785H22.734V18.9213H21.6426ZM23.9816 15.5501H22.734V16.4643H23.9977C24.2165 16.4643 24.4986 16.2957 24.4986 16.0072C24.4986 15.7829 24.2809 15.5501 23.9816 15.5501Z",
    fill: "#016FD0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.121 18.9213V17.9785H32.3053C32.6285 17.9785 32.7684 17.8047 32.7684 17.6142C32.7684 17.4316 32.6289 17.2471 32.3053 17.2471H31.3182C30.4603 17.2471 29.9824 16.7271 29.9824 15.9464C29.9824 15.2501 30.42 14.5786 31.695 14.5786H33.8204L33.3608 15.5557H31.5226C31.1712 15.5557 31.0631 15.7391 31.0631 15.9143C31.0631 16.0943 31.1968 16.2928 31.4652 16.2928H32.4992C33.4556 16.2928 33.8706 16.8325 33.8706 17.5392C33.8706 18.299 33.4082 18.9213 32.4471 18.9213H30.121Z",
    fill: "#016FD0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1269 18.9213V17.9785H36.3112C36.6344 17.9785 36.7743 17.8047 36.7743 17.6142C36.7743 17.4316 36.6348 17.2471 36.3112 17.2471H35.3241C34.4661 17.2471 33.9883 16.7271 33.9883 15.9464C33.9883 15.2501 34.4259 14.5786 35.7008 14.5786H37.8263L37.3667 15.5557H35.5285C35.1771 15.5557 35.0689 15.7391 35.0689 15.9143C35.0689 16.0943 35.2026 16.2928 35.4711 16.2928H36.505C37.4615 16.2928 37.8765 16.8325 37.8765 17.5392C37.8765 18.299 37.414 18.9213 36.453 18.9213H34.1269Z",
    fill: "#016FD0"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAmericanExpress, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/american-express.c57a5b8d.svg";
export { ForwardRef as ReactComponent };